(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mpi-calcolo-spedizione"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mpi-shipping-calculator')) {
    customElements.define(
      'mpi-shipping-calculator',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.config = JSON.parse(
            this.querySelector('[data-config]').textContent
          );

          this.country = this.querySelector('[data-country]');
          this.province = this.querySelector('[data-province]');
          this.provinceField = this.querySelector('[data-province-field]');
          this.zip = this.querySelector('[data-zip]');
          this.result = this.querySelector('[data-result]');
          this.button = this.querySelector('[data-calculate]');
          this.revision = 0;

          const visibleCountries = new Set([
  'Italy', 'Austria', 'Belgium', 'Bulgaria', 'Croatia',
  'Cyprus', 'Czech Republic', 'Czechia', 'Denmark',
  'Estonia', 'Finland', 'France', 'Germany', 'Greece',
  'Hungary', 'Ireland', 'Latvia', 'Lithuania',
  'Luxembourg', 'Malta', 'Netherlands', 'Poland',
  'Portugal', 'Romania', 'Slovakia', 'Slovenia',
  'Spain', 'Sweden', 'Switzerland', 'United Kingdom',
  'United States', 'Canada', 'China', 'Japan',
  'South Korea', 'Taiwan'
]);

this.excludedCountries = document.createDocumentFragment();

Array.from(this.country.options).forEach((option) => {
  if (!visibleCountries.has(option.value)) {
    this.excludedCountries.appendChild(option);
  }
});

this.country.value = 'Italy';

          this.updateProvinces();

          this.country.addEventListener('change', () => {
            this.updateProvinces();
            this.invalidate();
          });

          this.province.addEventListener('change', () => this.invalidate());
          this.zip.addEventListener('input', () => this.invalidate());

          this.button.addEventListener('click', () => this.calculate());

          this.zip.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.calculate();
            }
          });
        }

        disconnectedCallback() {
          this.revision += 1;
          if (this.controller) this.controller.abort();
        }

        invalidate() {
          this.revision += 1;
          if (this.controller) this.controller.abort();
          this.result.replaceChildren();
          this.button.disabled = false;
          this.removeAttribute('aria-busy');
        }

        updateProvinces() {
          const option = this.country.options[this.country.selectedIndex];
          let provinces = [];

          try {
            provinces = JSON.parse(option?.dataset.provinces || '[]');
          } catch (error) {
            provinces = [];
          }

          this.province.replaceChildren();

          if (provinces.length) {
            this.province.add(
              new Option(this.config.text.provincePlaceholder, '')
            );

            provinces.forEach(([code, name]) => {
              this.province.add(new Option(name, code));
            });
          }

          this.provinceField.hidden = provinces.length === 0;
          this.province.disabled = provinces.length === 0;
        }

        message(text, isError = false) {
          const paragraph = document.createElement('p');
          paragraph.className =
            'mpi-sc__message' +
            (isError ? ' mpi-sc__message--error' : '');
          paragraph.textContent = text;
          this.result.replaceChildren(paragraph);
        }

        async calculate() {
          if (this.button.disabled) return;

          if (!this.country.value) {
            this.message(this.config.text.countryRequired, true);
            this.country.focus();
            return;
          }

          if (!this.province.disabled && !this.province.value) {
            this.message(this.config.text.provinceRequired, true);
            this.province.focus();
            return;
          }

          if (!this.zip.value.trim()) {
            this.message(this.config.text.zipRequired, true);
            this.zip.focus();
            return;
          }

          if (this.controller) this.controller.abort();

          const controller = new AbortController();
          this.controller = controller;
          const revision = ++this.revision;

          this.button.disabled = true;
          this.setAttribute('aria-busy', 'true');
          this.message(this.config.text.loading);

          const params = new URLSearchParams({
            'shipping_address[country]': this.country.value,
            'shipping_address[zip]': this.zip.value.trim()
          });

          if (!this.province.disabled && this.province.value) {
            params.set(
              'shipping_address[province]',
              this.province.value
            );
          }

          const root = window.Shopify?.routes?.root || '/';
          const base = root.endsWith('/') ? root : root + '/';
          const options = {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: controller.signal
          };

          try {
            const prepared = await fetch(
              base + 'cart/prepare_shipping_rates.json?' + params.toString(),
              { ...options, method: 'POST' }
            );

            if (!prepared.ok) {
  const errorData = await prepared.json().catch(() => null);
  const countryErrors = errorData?.country;

  if (
    prepared.status === 422 &&
    Array.isArray(countryErrors) &&
    countryErrors.includes('Paese o area geografica non supportati')
  ) {
    if (revision !== this.revision || !this.isConnected) return;
    this.message(this.config.text.empty, true);
    return;
  }

  throw new Error('prepare_failed');
}


            let rates = null;

            for (let attempt = 0; attempt < 15; attempt += 1) {
              await new Promise((resolve) => setTimeout(resolve, 1000));

              if (revision !== this.revision || !this.isConnected) return;

              const response = await fetch(
                base + 'cart/async_shipping_rates.json?' + params.toString(),
                options
              );

              if (!response.ok) throw new Error('rates_failed');

              const data = await response.json();

              if (data && Array.isArray(data.shipping_rates)) {
                rates = data.shipping_rates;
                break;
              }
            }

            if (revision !== this.revision || !this.isConnected) return;

            if (rates === null) {
              this.message(this.config.text.timeout, true);
              return;
            }

            if (!rates.length) {
              this.message(this.config.text.empty, true);
              return;
            }

            const formatter = new Intl.NumberFormat(
              this.config.locale || 'it',
              {
                style: 'currency',
                currency: this.config.currency
              }
            );

            const fragment = document.createDocumentFragment();

            rates.forEach((rate) => {
              const row = document.createElement('p');
              row.className = 'mpi-sc__message';

              const name = document.createElement('strong');
              name.textContent = rate.name;

              const numericPrice = Number(rate.price);
              const price =
                numericPrice === 0
                  ? this.config.text.free
                  : Number.isFinite(numericPrice)
                    ? formatter.format(numericPrice)
                    : String(rate.price);

              row.append(
                name,
                document.createTextNode(': ' + price)
              );

              fragment.append(row);
            });

            this.result.replaceChildren(fragment);
          } catch (error) {
            if (
              error.name !== 'AbortError' &&
              revision === this.revision &&
              this.isConnected
            ) {
              this.message(this.config.text.error, true);
            }
          } finally {
            if (revision === this.revision) {
              this.button.disabled = false;
              this.removeAttribute('aria-busy');
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
